module.exports = __webpack_public_path__ + "img/American_Credit_Equipment_Loan_Process_Calendar.b930e35.png";